// ** React Imports
import { Fragment } from "react";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import SexIcon from "components/icons/SexIcon";
import SportIcon from "components/icons/SportIcon";
import HobbyIcon from "components/icons/HobbyIcon";
import LifeStyleIcon from "components/icons/LifeStyleIcon";
import CultureIcon from "components/icons/CultureIcon";
import FoodIcon from "components/icons/FoodIcon";

export const preferencesgroupedByCategory = ({
	groupedByCategory,
	currentSelectedItems,
	t,
}) => {
	const selectedLimitText = t("userpanel:data.cantSaveMorePreferences");
	const customSelectedLimitText = selectedLimitText?.replace(/10/g, "20");

	if (currentSelectedItems.length > 20) {
		return customSelectedLimitText;
	}

	const renderNewPreferences = ({
		data,
		transKey,
		icon,
		withMarginBottom,
	}) => {
		if (!data.length) {
			return null;
		}

		const result = data
			.filter((item) => item !== null)
			.sort((a, b) => {
				return t(`filtersAndSelectors:preferences.${a}`).localeCompare(
					t(`filtersAndSelectors:preferences.${b}`),
					undefined,
					{
						numeric: false,
						sensitivity: "base",
					}
				);
			})
			.map((item, index) => {
				return (
					<Fragment key={item.value}>
						{t(`filtersAndSelectors:preferences.${item.value}`)}
						{data[index + 1] && ", "}
					</Fragment>
				);
			});
		return (
			<Block
				mb={withMarginBottom ? 2 : 0}
				flex
				bold
				style={{ lineHeight: 1.5 }}
			>
				<Block>{icon}</Block>
				<Block>
					<Text bold="normal">{transKey}</Text>
					<Text mr={1}>:</Text>
					{result}
				</Block>
			</Block>
		);
	};

	return (
		<Block mt={2}>
			{renderNewPreferences({
				data: groupedByCategory.sex || [],
				transKey: t("filtersAndSelectors:categoryPreferences.0"),
				icon: <SexIcon />,
				withMarginBottom: true,
			})}
			{renderNewPreferences({
				data: groupedByCategory.sport || [],
				transKey: t("filtersAndSelectors:categoryPreferences.2"),
				icon: <SportIcon />,
				withMarginBottom: true,
			})}
			{renderNewPreferences({
				data: groupedByCategory.hobby || [],
				transKey: t("filtersAndSelectors:categoryPreferences.3"),
				icon: <HobbyIcon />,
				withMarginBottom: true,
			})}
			{renderNewPreferences({
				data: groupedByCategory.life_style || [],
				transKey: t("filtersAndSelectors:categoryPreferences.5"),
				icon: <LifeStyleIcon />,
				withMarginBottom: true,
			})}
			{renderNewPreferences({
				data: groupedByCategory.culture || [],
				transKey: t("filtersAndSelectors:categoryPreferences.4"),
				icon: <CultureIcon />,
				withMarginBottom: true,
			})}
			{renderNewPreferences({
				data: groupedByCategory.food || [],
				transKey: t("filtersAndSelectors:categoryPreferences.1"),
				icon: <FoodIcon />,
				withMarginBottom: false,
			})}
		</Block>
	);
};
